import { TextArea } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FormBodyWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  padding: 0 6rem;
  justify-content: space-between;
`;

export const TextAreaStyled = styled(TextArea)`
  flex-grow: 1;
  margin-bottom: 4.6rem;
`;
